module.exports = __webpack_public_path__ + "img/130ne.caf0ed1d.svg";